<template>
	<page>
		<row>
			<c-col>
				<games-table @edit="onEdit" @share="onShare" />
			</c-col>
		</row>
		<share-dialog v-model="shareDialogOpen" :game="shareGame" />
	</page>
</template>

<script>
import GamesTable from "src/view/games/GamesTable";
import GameModule from "src/store/modules/Game.module";
import ShareDialog from "src/view/share/ShareDialog";

export default {
	name: "GamesView",
	components: {
		ShareDialog,
		GamesTable
	},
	data() {
		return {
			openModal: false,
			shareDialogOpen: false,
			shareGame: {}
		};
	},
	methods: {
		onShare(game) {
			this.shareGame = game;
			this.shareDialogOpen = true;
		},
		createNew() {
			this.$store.commit(GameModule.types.GET, { public: true, share: true });
			this.$router.push({
				name: "game-form-create"
			});
		},
		onEdit(game) {
			this.$store.commit(GameModule.types.GET, game);
			this.$router.push({
				name: "game-form",
				params: { id: game.id, typeId: game.type_id }
			}); // -> /user/123
		},
		onSave(game) {
			this.openModal = false;
			this.$store.commit(GameModule.types.GET, game);
			this.$router.push({
				name: "game-form",
				params: { id: game.id }
			});
		}
	}
};
</script>

<style scoped></style>
